module.exports = __webpack_public_path__ + "img/img2.c0ea8198.png";